import {formatCdnPath, formatCdnPathWithVariant} from "../../utils/getCdnUrl"

export const ACTIVE = "active"
export const INACTIVE = "inactive"

export default Object.freeze({
    searchBox: {
        searchIconUrl: (realm: string, variant: string, iconsVersionPath: string): string =>
            formatCdnPathWithVariant("search.svg", realm, variant, iconsVersionPath),
        searchInputButtonUrl: (realm: string, variant: string, iconsVersionPath: string): string =>
            formatCdnPathWithVariant("search-input-button.svg", realm, variant, iconsVersionPath),
        clearButton: {
            path: formatCdnPath("/icons/shared/clear.svg"),
        },
        clearButtonRealmSpecific: (realm: string, variant: string, iconsVersionPath: string): string =>
            formatCdnPathWithVariant("clear.svg", realm, variant, iconsVersionPath),
    },
    myAccount: {
        loginUrl: "/secure/accounts/transfer",
        signoutUrl: "/forget-me",
        tooltipIconUrl: (realm: string, variant: string, iconsVersionPath: string): string =>
            formatCdnPathWithVariant("account-tooltip.svg", realm, variant, iconsVersionPath),
    },
    checkout: {
        url: "/secure/checkout/transfer/checkoutcta",
    },
    autoComplete: {
        images: {
            AltItemZoomDir: "AltItemZoom",
            AltItemThumbDir: "AltItemThumb",
            newDirectoryName: "search/224x336",
        },
    },
    drawer: {
        iconUrl: formatCdnPath("/icons/shared/next_close-white.svg"),
    },
    favourites: {
        url: "/favourites",
        iconUrl: (realm: string, variant: string, active: boolean, size: string, iconsVersionPath: string) =>
            formatCdnPathWithVariant(
                `favourites-${active ? ACTIVE : INACTIVE}-${size}.svg`,
                realm,
                variant,
                iconsVersionPath,
            ),
    },
    shoppingBag: {
        smallIconUrl: (realm: string, variant: string, iconsVersionPath: string) =>
            formatCdnPathWithVariant("shopping-bag-small.svg", realm, variant, iconsVersionPath),
        largeIconUrl: (realm: string, variant: string, iconsVersionPath: string) =>
            formatCdnPathWithVariant("shopping-bag-large.svg", realm, variant, iconsVersionPath),
        url: "/shoppingbag",
    },
    countryLangSelector: {
        countrySelectUrl: "/countryselect",
    },
    burgerMenu: {
        menuUrl: (realm: string, variant: string, iconsVersionPath: string) =>
            formatCdnPathWithVariant("burger-menu.svg", realm, variant, iconsVersionPath),
        closeUrl: (realm: string, variant: string, iconsVersionPath: string) =>
            formatCdnPathWithVariant("burger-close.svg", realm, variant, iconsVersionPath),
        chevronUrl: (realm: string, variant: string, iconsVersionPath: string) =>
            formatCdnPathWithVariant("chevron-down-m-default.svg", realm, variant, iconsVersionPath),
        favourites: (realm: string, active: boolean, iconsVersionPath: string) =>
            formatCdnPathWithVariant(
                `favourites-${active ? ACTIVE : INACTIVE}.svg`,
                realm,
                undefined,
                iconsVersionPath,
            ),
    },
    queueIt: {
        host: "https://static.queue-it.net",
        clientUrl: "//static.queue-it.net/script/queueclient.min.js",
        configLoader: "//static.queue-it.net/script/queueconfigloader.js",
    },
    abPlatformTesting: {
        configsPath: "/configs/abplatform/",
        personasConfigPath: "/abtesting-sdk/",
        baseFile: "abplatform.js",
        configFile: "abplatformconfig.js",
    },
    drawerCloseIcon: formatCdnPath("/icons/shared/next_close-white.svg"),
    closeIconBlack: formatCdnPath("/icons/shared/close.svg"),
    crossIconBlack: formatCdnPath("/icons/shared/cross.svg"),
    arrowIconUrl: formatCdnPath("/icons/shared/chevron.svg"),
    leftWhiteArrowIconUrl: formatCdnPath("/icons/shared/chevron-white-left.svg"),
    rightWhiteArrowIconUrl: formatCdnPath("/icons/shared/chevron-white-right.svg"),
    informationIconUrl: (realm: string): string => formatCdnPathWithVariant("information.svg", realm),
    signout: {
        url: "/xhos/signout/",
    },
})
